var _g, _circle, _rect, _path, _rect2, _g2, _rect3, _rect4, _rect5, _g3, _rect6, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyAutomate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 264,
    viewBox: "0 0 255 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_1667_17280_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.106347 0.255233 -0.255233 -0.106347 127.5 136.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.285,
    height: 605.285,
    fill: "url(#paint0_diamond_1667_17280)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.285,
    height: 605.285,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_1667_17280)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.285,
    height: 605.285,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_1667_17280)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.285,
    height: 605.285,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_1667_17280)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 136.25,
    r: 127.25,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.062745101749897003,\"g\":0.63921570777893066,\"b\":0.49803921580314636,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.64999997615814209},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.65206468105316162}],\"stopsVar\":[{\"color\":{\"r\":0.062745101749897003,\"g\":0.63921570777893066,\"b\":0.49803921580314636,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.64999997615814209},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.65206468105316162}],\"transform\":{\"m00\":-212.69454956054688,\"m01\":-510.46685791015625,\"m02\":489.08071899414062,\"m10\":510.46685791015625,\"m11\":-212.69454956054688,\"m12\":-12.636165618896484},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    width: 66,
    height: 66,
    rx: 33,
    fill: "#E8E9ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.729 28.3333C122.167 28.3333 123.333 27.1674 123.333 25.7292C123.333 24.2909 122.167 23.125 120.729 23.125C119.291 23.125 118.125 24.2909 118.125 25.7292C118.125 27.1674 119.291 28.3333 120.729 28.3333ZM120.729 28.3333V36.6667M120.729 36.6667C119.291 36.6667 118.125 37.8326 118.125 39.2708C118.125 40.7091 119.291 41.875 120.729 41.875C122.167 41.875 123.333 40.7091 123.333 39.2708C123.333 37.8326 122.167 36.6667 120.729 36.6667ZM134.271 36.6667V29.0625C134.271 27.8957 134.271 27.3123 134.044 26.8667C133.844 26.4747 133.525 26.156 133.133 25.9562C132.688 25.7292 132.104 25.7292 130.937 25.7292H127.5M134.271 36.6667C135.709 36.6667 136.875 37.8326 136.875 39.2708C136.875 40.7091 135.709 41.875 134.271 41.875C132.833 41.875 131.667 40.7091 131.667 39.2708C131.667 37.8326 132.833 36.6667 134.271 36.6667ZM127.5 25.7292L130.104 28.3333M127.5 25.7292L130.104 23.125",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 82,
    width: 198.759,
    height: 61.6081,
    rx: 5.86743,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1667_17280)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6023,
    height: 17.6023,
    transform: "translate(50.5027 104.003)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5024,
    y: 104.003,
    width: 17.6023,
    height: 17.6023,
    rx: 8.80115,
    fill: "#10A37F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.9691,
    y: 105.513,
    width: 14.6686,
    height: 13.8922,
    rx: 6.94611,
    fill: "#10A37F"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86.4409,
    y: 98.501,
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.4409,
    y: 114.637,
    width: 92.4121,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 161.609,
    width: 198.759,
    height: 61.6081,
    rx: 5.86743,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1667_17280)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6023,
    height: 17.6023,
    transform: "translate(50.5027 183.612)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5022,
    y: 183.612,
    width: 17.6023,
    height: 17.6023,
    rx: 8.80115,
    fill: "#10A37F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.9691,
    y: 185.122,
    width: 14.6686,
    height: 13.8922,
    rx: 6.94611,
    fill: "#10A37F"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 86.4409,
    y: 178.11,
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 86.4409,
    y: 194.246,
    width: 92.4121,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_1667_17280_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 136.25,
    r: 127.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_1667_17280",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E8E9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652065,
    stopColor: "#E8E9ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1667_17280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6023,
    height: 17.6023,
    fill: "white",
    transform: "translate(50.5027 104.003)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1667_17280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6023,
    height: 17.6023,
    fill: "white",
    transform: "translate(50.5027 183.612)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAutomate);
export default __webpack_public_path__ + "static/media/emptyAutomate.bb0578225834fc80aa966c851682cd0c.svg";
export { ForwardRef as ReactComponent };